export * from './ESasPropostaTexts';